import React, { useCallback, useState } from "react";
import { Paper, Box, Tabs, Tab, Container, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCreditCard,
  faPeopleArrows,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";

import { getRuta } from "../../../helpers/Helpers";
import { PageHeader } from "../../../components/base";
import ClientDetails from "./ClientDetails";
import ClientReferences from "./ClientReferences";
import ClientCredits from "./ClientCredits";
import ResumenCliente from "./ResumenCliente";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`cliente-tabpanel-${index}`}
      aria-labelledby={`cliente-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// Cada pestaña lleva su propio índice: el id de la pestaña y el del panel se corresponden.
function a11yProps(index) {
  return {
    id: `cliente-tab-${index}`,
    "aria-controls": `cliente-tabpanel-${index}`,
  };
}

export const DetalleClientContainer = () => {
  let ruta = getRuta();
  let navigate = useNavigate();
  const { id } = useParams();
  const [value, setValue] = useState(0);

  // Lo que ya cargaron las pestañas, para el encabezado y el resumen (sin pedir nada nuevo):
  // los datos del cliente salen de la pestaña "Cliente" y la cantidad de créditos de "Créditos".
  const [cliente, setCliente] = useState(null);
  const [creditos, setCreditos] = useState(null);
  // Si la pestaña "Cliente" falla, el resumen deja de esperar y muestra "—".
  const [falloCliente, setFalloCliente] = useState(false);
  const alCargarDatos = useCallback((datos) => {
    setCliente(datos);
    setFalloCliente(false);
  }, []);
  const alFallarDatos = useCallback(() => setFalloCliente(true), []);
  const alCargarCreditos = useCallback((cantidad) => setCreditos(cantidad), []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Button
        onClick={() => {
          navigate(`${ruta}/clients`);
        }}
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 1 }}
      >
        Volver a clientes
      </Button>

      <PageHeader
        titulo={cliente?.fullName || "Detalle del cliente"}
        subtitulo={`Cliente #${id}`}
        icono={<FontAwesomeIcon icon={faUser} />}
      />

      <ResumenCliente
        cliente={cliente}
        fallo={falloCliente}
        creditos={creditos}
        onVerCreditos={() => setValue(2)}
      />

      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Secciones del cliente"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab
            icon={<FontAwesomeIcon icon={faUser} />}
            iconPosition="start"
            label="Cliente"
            {...a11yProps(0)}
          />

          <Tab
            icon={<FontAwesomeIcon icon={faPeopleArrows} />}
            iconPosition="start"
            label="Referencias"
            {...a11yProps(1)}
          />

          <Tab
            icon={<FontAwesomeIcon icon={faCreditCard} />}
            iconPosition="start"
            label="Créditos"
            {...a11yProps(2)}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <ClientDetails id={id} onDatos={alCargarDatos} onFallo={alFallarDatos} />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ClientReferences id={id} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <ClientCredits id={id} onCargado={alCargarCreditos} />
        </TabPanel>
      </Paper>
    </Container>
  );
};
